import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { useAuthContext } from '../../../../../common/hooks/use-auth-context.hook';
import { useVisitorTracking } from '../../../../../common/hooks/use-visitor-tracking.hook';

/**
 * Who is on the visualizer this minute, from the live socket. The one moving
 * thing on the page — a pulsing dot while someone is there, a still grey one
 * when nobody is.
 */
export function LiveNow({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const count = useVisitorTracking(user?.vendor?.alias);
  const live = count > 0;
  return (
    <span
      className={cn('inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-xs whitespace-nowrap', className)}
      data-testid="viz-live-now"
    >
      <span className="relative flex size-2">
        {live && <span className="absolute inline-flex size-full animate-ping rounded-full bg-success opacity-75" />}
        <span className={cn('relative inline-flex size-2 rounded-full', live ? 'bg-success' : 'bg-muted-foreground/40')} />
      </span>
      <span className="tabular-nums">{t('VIZ_ANALYTICS.LIVE.NOW', { count })}</span>
    </span>
  );
}
